var Container = (props)=>(<div style={{width:"100%"}}>
    <div style={{maxWidth:"1024px",margin:"0 auto",padding:"15px"}}>{props.children}</div>
    </div>
)
export default Container